export default __webpack_public_path__ + "static/uipath-newlogo-mobile-3de332da18e38cdb93779585823b0da3.svg";